import { render, staticRenderFns } from "./CreatePromo.vue?vue&type=template&id=63dfd837&scoped=true&"
import script from "./CreatePromo.vue?vue&type=script&lang=js&"
export * from "./CreatePromo.vue?vue&type=script&lang=js&"
import style0 from "./CreatePromo.vue?vue&type=style&index=0&id=63dfd837&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfd837",
  null
  
)

export default component.exports